























import { defineComponent, nextTick, ref, watch } from "@vue/composition-api";

import { format, parse } from "date-fns/esm";

interface Props {
  date: string;
}

export default defineComponent({
  name: "SimpleDateInput",
  props: {
    date: { type: String }
  },
  setup(props: Props, context) {
    const pending = ref<string | null>(
      props.date
        ? format(parse(props.date, "M/d/y", new Date()), "y-MM-dd")
        : null
    );

    const isEditing = ref(false);

    const commit = () => {
      context.emit(
        "commit",
        pending.value !== null
          ? format(parse(pending.value, "y-MM-dd", new Date()), "M/d/y")
          : null
      );
      isEditing.value = false;
    };

    const cancel = () => {
      isEditing.value = false;
      pending.value =
        props.date !== null
          ? format(parse(props.date, "M/d/y", new Date()), "y-MM-dd")
          : null;
    };

    watch(() => props.date, cancel);

    return {
      pending,
      isEditing,
      commit,
      cancel
    };
  }
});
